export default __webpack_public_path__ + "static/media/Klimaatplafonds.ce288b32.png";